<template>
  <div class="pcard d-flex flex-column mr-4" style="border: 1px solid #e0e0e0; border-radius: 8px; height: 100%;">
    <!-- Top Row: Status and Period -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div class="font-weight-bold" style="font-size: 1.1rem; color: #495057;">
        {{ $t("audit-control.status." + control.status.toLowerCase()) }}
      </div>
      <div class="flex-shrink-0">
        <div style="background: white; padding: 6px 12px; border-radius: 6px; border: 1px solid #ccc; font-size: 0.95rem;">
          <span class="font-weight-bold mr-1">{{ $t("audit-control.control.period") }}:</span>
          <span v-if="control.period">{{ control.period.value }} {{ $t("audit-control.unit." + (control.period.unit || "MONTH").toLowerCase()) }}</span>
          <span v-else>-</span>
        </div>
      </div>
    </div>

    <!-- Control No & Criticality -->
    <div class="row mb-3">
      <div class="col-6">
        <div class="font-weight-bold mb-1">{{ $t("audit-control.control.no") }}</div>
        <div style="color: #495057;">{{ control.no || "-" }}</div>
      </div>
      <div class="col-6">
        <div class="font-weight-bold mb-1">{{ $t("audit-control.control.criticality") }}</div>
        <div style="color: #495057;">{{ control.criticality ? $t("audit-control.criticality." + control.criticality.toLowerCase()) : "-" }}</div>
      </div>
    </div>

    <!-- Description -->
    <div class="mb-3">
      <div class="font-weight-bold mb-1">{{ $t("audit-control.control.description") }}</div>
      <div
        class="text-break"
        style="display: -webkit-box; -webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis; min-height: 2.8rem; color: #495057;"
        :title="control.name ? $options.filters.translate(control.name) : ''"
      >
        {{ control.name ? $options.filters.translate(control.name) : "-" }}
      </div>
    </div>

    <!-- Category & Type -->
    <div class="row mb-3">
      <div class="col-6">
        <div class="font-weight-bold mb-1">{{ $t("audit-control.control.category") }}</div>
        <div class="text-break text-truncate" :title="control.category ? $options.filters.translate(control.category.name) : ''" style="color: #495057;">
          <span v-if="control.category">{{ control.category.name | translate }}</span>
          <span v-else>-</span>
        </div>
      </div>
      <div class="col-6">
        <div class="font-weight-bold mb-1">{{ $t("audit-control.control.type") }}</div>
        <div class="text-break text-truncate" :title="control.type ? $options.filters.translate(control.type.name) : ''" style="color: #495057;">
          <span v-if="control.type">{{ control.type.name | translate }}</span>
          <span v-else>-</span>
        </div>
      </div>
    </div>

    <!-- Owner and Manager Row -->
    <div class="row mb-4">
      <div class="col-6">
        <div class="font-weight-bold mb-1">{{ $t("audit-control.control.owner") }}</div>
        <div class="text-break text-truncate" style="color: #495057;">
          <span v-if="control.owner && control.owner.organization">{{ control.owner.organization.name }}</span>
          <span v-else-if="control.owner && control.owner.department">{{ control.owner.department.name | translate }}</span>
          <span v-else-if="control.owner && control.owner.process">{{ control.owner.process.name | translate }}</span>
          <span v-else>-</span>
        </div>
      </div>
      <div class="col-6">
        <div class="font-weight-bold mb-1">{{ $t("audit-control.control.manager") }}</div>
        <div class="text-break text-truncate" :title="control.manager ? control.manager.name : ''" style="color: #495057;">
          <span v-if="control.manager">{{ control.manager.name }}</span>
          <span v-else>-</span>
        </div>
      </div>
    </div>

    <!-- Button -->
    <div class="mt-auto pt-2">
      <b-button block variant="outline-primary" @click="$emit('edit', control)">
        <strong>{{ $t("audit-control.control.management") }}</strong>
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    control: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@modules/core/compliance-item/organization-policy.scss";
</style>
